import { render, staticRenderFns } from "./FailPaymant.vue?vue&type=template&id=58faf85e&scoped=true&"
import script from "./FailPaymant.vue?vue&type=script&lang=js&"
export * from "./FailPaymant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58faf85e",
  null
  
)

export default component.exports